import gameConfig from "../../engines/configs/gameConfig";
import O1HD from "../../engines/gameEngine";
import data_control from "../../engines/libs/data_control";
import utilsModel from "../../engines/libs/utilsModel";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { MessageEventKind } from "../../modes/define/MessageEventKind";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import dartGame from "./dartGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class dartGameStartPage extends cc.Component {

    @property({type:cc.Prefab,tooltip:"游戏预制体"})
    gamePrefab:cc.Prefab = null;

    @property({type:cc.Node,tooltip:"按钮节点"})
    btnsAry:cc.Node[] = [];

    rewardAry:number[] = [500000,5000000,10000000];
    cashDepositAry:number[] = [100000,500000,2000000];

    banditAry:number[] = [7,6,5];
    armedAry:number[] = [1,2,3];

    start(){
        this.loadPlayDay();
        this.updateBtns();
    }

    onBtnSelectOne(e:cc.Event.EventTouch,custom:string){
        let fun = ()=>{
            let index:number = Number(custom);
            let reward = this.rewardAry[index];
            let cash = this.cashDepositAry[index];
            let bandit = this.banditAry[index];
            let armed = this.armedAry[index];
            let meCoin:number = O1HD.getServices().userSrv.getCoins();
            if(meCoin < cash){
                NormalGameManager._instance.openBankPage();
                return;
            }
            O1HD.getServices().userSrv.setCoins(-cash,true);
            let node:cc.Node = cc.instantiate(this.gamePrefab);
            O1HD.Canvas().addChild(node);
            let ns = node.getComponent(dartGame);
            ns.bindData(cash,reward,armed,bandit);
            this.closeThis();
        }
        if(this.canFreePlay()){
            fun();
            this.setPlayCount(1,true);
        }else{
            utilsModel.loadAndShowVideoAdTrans(()=>{
                fun();
            },()=>{},null,"看广告进入押镖");
        }
    }

    closeThis(){
        this.node.destroy();
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    updateBtns(){
        for(let i =0;i<this.btnsAry.length;i++){
            let btn:cc.Node = this.btnsAry[i];
            let layout = btn.getChildByName("layout");
            let video:cc.Node = layout.getChildByName("video");
            video.active = !this.canFreePlay();
        }
    }

    private dartGame_day_key:string = "dart-game-day-key";
    private dart_play_count_key:string = "dart-game-play-count-key";

    loadPlayDay(){
        let dayStr:string = O1HD.getServices().localStorageSrv.getStorage(this.dartGame_day_key);
        if(dayStr != data_control.getCurrDateDayString()){
            O1HD.getServices().localStorageSrv.setStorage(this.dartGame_day_key,data_control.getCurrDateDayString());
            this.setPlayCount(0,false);
        }
    }

    getPlayCount(){
        let countStr:string = O1HD.getServices().localStorageSrv.getStorage(this.dart_play_count_key);
        let count:number= Number(countStr);
        if(isNaN(count)){
            count = 0;
        }
        return count;
    }

    setPlayCount(count:number,isPlus:boolean){
        let curCount:number = this.getPlayCount();
        if(isPlus){
            curCount += count;
        }else{
            curCount = count;
        }
        O1HD.getServices().localStorageSrv.setStorage(this.dart_play_count_key,curCount);
    }

    canFreePlay(){
        return this.getPlayCount() < gameConfig.DART_EVERY_DAY_CAN_PLAY_COUNT;
    }


}
